// Generated by scripts/build-tokens.mjs from scripts/tokens/upstream-snapshot.css.
// Do not edit by hand — change the generator or the snapshot.
//
// The token value vocabulary tailwind-merge needs in order to treat two Strix
// utilities as conflicting. See cn.ts for why this cannot be hand-maintained.

export const TOKEN_CLASS_GROUPS = {
  radius: {
    utilities: [
      'rounded',
      'rounded-s',
      'rounded-e',
      'rounded-t',
      'rounded-r',
      'rounded-b',
      'rounded-l',
      'rounded-ss',
      'rounded-se',
      'rounded-ee',
      'rounded-es',
      'rounded-tl',
      'rounded-tr',
      'rounded-br',
      'rounded-bl',
    ],
    values: [
      '2x-large',
      'extra-large',
      'large',
      'lg',
      'lg-sm',
      'md',
      'med-sm',
      'med-xs',
      'medium',
      'sm',
      'small',
      'xl',
      'xs',
      'xxl',
      'xxs',
      'xxxl',
    ],
  },
  shadow: {
    utilities: ['shadow'],
    values: ['active', 'demo-card', 'glass', 'md', 'phone-loading', 'sm', 'sm-right', 'xs'],
  },
  blur: {
    utilities: ['blur', 'backdrop-blur'],
    values: ['full', 'lg', 'md', 'sm', 'splash', 'xl', 'xs', 'xxl', 'xxs', 'xxxl'],
  },
  animate: {
    utilities: ['animate'],
    values: ['badge-pulse', 'popup-in', 'popup-out', 'skeleton-shimmer', 'waiting-square'],
  },
  leading: {
    utilities: ['leading'],
    values: [
      'height-body-large',
      'height-body-medium',
      'height-body-small',
      'height-body-xsmall',
      'height-cta-medium-xsmall',
      'height-cta-regular-large',
      'height-cta-regular-medium',
      'height-cta-regular-small',
      'height-cta-strong-large',
      'height-cta-strong-medium',
      'height-cta-strong-small',
      'height-d1',
      'height-d2',
      'height-d3',
      'height-d4',
      'height-d5',
      'height-d6',
      'height-d7',
      'height-eyebrow-large',
      'height-eyebrow-small',
      'height-figma-12',
      'height-figma-14',
      'height-figma-16',
      'height-figma-18',
      'height-figma-20',
      'height-figma-24',
      'height-figma-28',
      'height-figma-32',
      'height-figma-40',
      'height-figma-48',
      'height-figma-mono-12',
      'height-figma-title-24',
      'height-h1',
      'height-h2',
      'height-h3',
      'height-h4',
      'height-h5',
      'height-h6',
      'height-h7',
      'height-mono-large',
      'height-mono-medium',
      'height-mono-small',
      'height-subhead-large',
      'height-subhead-medium',
      'height-subhead-small',
    ],
  },
  tracking: {
    utilities: ['tracking'],
    values: [
      'body-large',
      'body-medium',
      'body-small',
      'body-xsmall',
      'cta-medium-xsmall',
      'cta-regular-large',
      'cta-regular-medium',
      'cta-regular-small',
      'cta-strong-large',
      'cta-strong-medium',
      'cta-strong-small',
      'd1',
      'd2',
      'd3',
      'd4',
      'd5',
      'd6',
      'd7',
      'eyebrow-large',
      'eyebrow-small',
      'h1',
      'h2',
      'h3',
      'h4',
      'h5',
      'h6',
      'h7',
      'mono-large',
      'mono-medium',
      'mono-small',
      'subhead-large',
      'subhead-medium',
      'subhead-small',
    ],
  },
  fontSize: {
    utilities: ['text-size'],
    values: [
      'body-large',
      'body-medium',
      'body-small',
      'body-xsmall',
      'cta-medium-xsmall',
      'cta-regular-large',
      'cta-regular-medium',
      'cta-regular-small',
      'cta-strong-large',
      'cta-strong-medium',
      'cta-strong-small',
      'd1',
      'd2',
      'd3',
      'd4',
      'd5',
      'd6',
      'd7',
      'eyebrow-large',
      'eyebrow-small',
      'figma-12',
      'figma-14',
      'figma-16',
      'figma-18',
      'figma-20',
      'figma-24',
      'figma-28',
      'figma-32',
      'figma-40',
      'figma-48',
      'h1',
      'h2',
      'h3',
      'h4',
      'h5',
      'h6',
      'h7',
      'mono-large',
      'mono-medium',
      'mono-small',
      'subhead-large',
      'subhead-medium',
      'subhead-small',
    ],
  },
  zIndex: {
    utilities: ['z'],
    values: ['base', 'deep', 'max', 'modal', 'overlay', 'popover', 'raised', 'sticky', 'toast', 'tooltip'],
  },
  fontWeightRoles: {
    utilities: ['font'],
    values: [
      'body-large-regular',
      'body-large-semibold',
      'body-medium-medium',
      'body-medium-regular',
      'body-medium-semibold',
      'body-small-medium',
      'body-small-regular',
      'body-small-semibold',
      'body-xsmall-regular',
      'body-xsmall-semibold',
      'cta-medium-xsmall',
      'cta-regular-large',
      'cta-regular-medium',
      'cta-regular-small',
      'cta-strong-large',
      'cta-strong-medium',
      'cta-strong-small',
      'd1',
      'd2',
      'd3',
      'd4',
      'd5',
      'd6',
      'd7',
      'eyebrow-large-regular',
      'eyebrow-large-semibold',
      'eyebrow-small-regular',
      'eyebrow-small-semibold',
      'h1',
      'h2',
      'h3',
      'h4',
      'h5',
      'h6',
      'h7',
      'mono-large-semibold',
      'mono-medium-medium',
      'mono-medium-regular',
      'mono-medium-semibold',
      'mono-small-regular',
      'subhead-large',
      'subhead-medium',
      'subhead-small',
    ],
  },
  spacing: {
    utilities: [],
    values: [
      '2x-large',
      '2x-small',
      'borders-bold',
      'borders-focus-otp',
      'borders-lg',
      'borders-md',
      'borders-medium',
      'borders-sm',
      'borders-thin',
      'borders-xl',
      'borders-xxl',
      'extra-large',
      'extra-small',
      'gap-050',
      'gap-100',
      'gap-1000',
      'gap-1300',
      'gap-150',
      'gap-200',
      'gap-250',
      'gap-300',
      'gap-400',
      'gap-500',
      'gap-600',
      'gap-700',
      'gap-800',
      'gap-900',
      'large',
      'medium',
      'medium-large',
      'medium-small',
      'padding-horizontal-lg',
      'padding-horizontal-md',
      'padding-horizontal-med-sm',
      'padding-horizontal-sm',
      'padding-horizontal-xl',
      'padding-horizontal-xs',
      'padding-horizontal-xxl',
      'padding-horizontal-xxs',
      'padding-horizontal-xxxl',
      'padding-horizontal-xxxs',
      'padding-vertical-3xl',
      'padding-vertical-4xl',
      'padding-vertical-5xl',
      'padding-vertical-6xl',
      'padding-vertical-7xl',
      'padding-vertical-lg',
      'padding-vertical-md',
      'padding-vertical-med-sm',
      'padding-vertical-sm',
      'padding-vertical-xl',
      'padding-vertical-xs',
      'padding-vertical-xxl',
      'padding-vertical-xxs',
      'padding-vertical-xxxs',
      'safe-bottom',
      'safe-left',
      'safe-right',
      'safe-top',
      'small',
      'touch-target',
      'touch-target-sm',
    ],
  },
} as const;
